// lib/telefonie/dialerEingabe.ts
// Deutet die eine Eingabezeile des Dialers: Buchstaben suchen Kontakte, Ziffern sind
// eine Nummer. Getrennt und getestet, weil an dieser Entscheidung hängt, was die halbe
// Seite anzeigt — und weil „sieht aus wie eine Nummer" mehr Randfälle hat, als man denkt.
import { normalisiereNummer } from './nummer';

export type DialerEingabe =
  | { art: 'leer' }
  | { art: 'suche'; begriff: string }
  /** `e164` ist null, solange die Ziffernfolge noch zu kurz zum Wählen ist. */
  | { art: 'nummer'; roh: string; e164: string | null };

/** Zeichen, die in einer getippten Nummer vorkommen dürfen, ohne sie zur Suche zu machen. */
const NUMMER_ZEICHEN = /^[+\d\s()\-/.]+$/;

export function deuteEingabe(text: string): DialerEingabe {
  const roh = (text ?? '').trim();
  if (roh === '') return { art: 'leer' };
  if (NUMMER_ZEICHEN.test(roh) && /\d/.test(roh)) {
    return { art: 'nummer', roh, e164: normalisiereNummer(roh) };
  }
  return { art: 'suche', begriff: roh };
}
